import { SvgIcon } from '@mui/material';
import React from 'react';

const SLOShippingInformationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m122.82,95.25v54.74H13.41V56.26h56.91c6.78,22.55,27.72,38.99,52.5,38.99Z" />
          <polygon points="65.53 51.1 13.41 51.1 29.14 30.41 65.53 30.41 65.53 51.1" />
        </g>
        <g>
          <path d="m154.36,14.61c.07.77.1,1.55.1,2.33,0,3.71-.73,7.25-2.04,10.47,1.76,4.1,2.73,8.61,2.73,13.35,0,18.84-15.34,34.16-34.18,34.16s-34.17-15.33-34.17-34.16c0-11.15,5.37-21.08,13.67-27.3.54-4.41,2.13-8.49,4.5-11.99-15.51,6.31-26.46,21.55-26.46,39.29,0,23.39,19.04,42.43,42.46,42.43s42.44-19.04,42.44-42.43c0-9.87-3.39-18.94-9.04-26.15Z" />
          <path d="m142.47,5.58c4,3.72,6.01,8.7,6.01,14.95,0,6.97-2.14,12.14-6.4,15.49-4.27,3.35-10.05,5.03-17.34,5.03l-.3,9.47h-7.78l-.39-15.74h2.86c6.5,0,11.59-1,15.27-2.99,3.68-1.99,5.52-5.74,5.52-11.26,0-3.99-1.18-7.14-3.55-9.47-2.36-2.33-5.55-3.49-9.56-3.49s-7.27,1.11-9.61,3.34c-2.33,2.23-3.5,5.26-3.5,9.12h-8.47c0-3.99.89-7.49,2.66-10.51,1.77-3.02,4.29-5.36,7.54-7.02,3.25-1.66,7.01-2.49,11.28-2.49,6.5,0,11.76,1.86,15.76,5.58Zm-26.31,63.56c-1.18-1.2-1.77-2.66-1.77-4.38s.59-3.19,1.77-4.38,2.63-1.79,4.33-1.79,3.04.6,4.19,1.79c1.15,1.2,1.72,2.66,1.72,4.38s-.58,3.19-1.72,4.38c-1.15,1.2-2.55,1.79-4.19,1.79s-3.15-.6-4.33-1.79Z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SLOShippingInformationIcon;
